import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';

import { CapsuleTableDataRow } from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/CapsulesTable/CapsulesTableDataRow';
import { CapsulesTableHead } from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/CapsulesTable/CapsulesTableHead';
import type { CapsulesTableProps } from 'new/modules/settings/capsules/viewModels/capsulesTableViewModel';
import styles from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/CapsulesTable/CapsulesTable.module.scss';

export const CapsulesTable: React.FC<CapsulesTableProps> = ({
  rows,
  onRowClick,
  onRowMenuAction,
  showRowActions = true,
}) => {
  const hasNoRows = rows.length === 0;

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      className={styles.tableContainer}
      data-testid="capsules-table"
    >
      <Table stickyHeader>
        <CapsulesTableHead />
        <TableBody>
          {rows.map((capsuleRow) => (
            <CapsuleTableDataRow
              key={capsuleRow.id}
              capsuleRow={capsuleRow}
              onRowClick={onRowClick}
              onRowMenuAction={onRowMenuAction}
              showRowActions={showRowActions}
            />
          ))}
          {hasNoRows && (
            <TableRow>
              <TableCell colSpan={4} className={styles.emptyStateCell}>
                <Typography variant="body2" data-testid="capsules-table-empty">
                  No capsules registered yet
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
